import React from 'react';

const ExportCSVButton = ({ data, fileName }) => {
  const convertToCSV = (objArray) => {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    if (array.length === 0) return '';
    
    
    const headerSet = new Set();
    array.forEach(item => {
      Object.keys(item).forEach(key => headerSet.add(key));
    });
    const headers = Array.from(headerSet);
    
    
    let csvContent = '';
    csvContent += headers.map(header => `"${header}"`).join(',') + '\r\n';
    
    
    for (let i = 0; i < array.length; i++) {
      const values = headers.map(header => {
        
        const value = array[i][header] === null || array[i][header] === undefined 
          ? '' 
          : String(array[i][header]);
          
      
        return `"${value.replace(/"/g, '""')}"`;
      });
      
      csvContent += values.join(',') + '\r\n';
    }
    
    return csvContent;
  };

  const downloadCSV = () => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      alert('No data to export');
      return;
    }
    
    
    let exportData = data;
    if (typeof data === 'object' && !Array.isArray(data)) {
      
      exportData = Object.values(data).flat();
    }
    
    const csvContent = convertToCSV(exportData);
    
    const BOM = "\uFEFF";
    const csvData = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button 
      className="px-4 py-2 bg-blue-500 text-white rounded-lg text-lg hover:shadow-lg"
      onClick={downloadCSV}
    >
      Export to CSV
    </button>
  );
};

export default ExportCSVButton;